const request = require("request");
const config = require("./config");

var getGrupos = (token) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          "Content-Type": "application/json",
          "User-Token": token,
        },
        uri: `${config.URL_BACKEND}/grupoOpcoesRecebimento`,
        method: "GET",
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

var getById = (token, id) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          "Content-Type": "application/json",
          "User-Token": token,
        },
        uri: `${config.URL_BACKEND}/grupoOpcoesRecebimento/${id}`,
        method: "GET",
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

module.exports = {
  getGrupos: getGrupos,
  getById: getById,
};
